class Homepage {
    constructor(injector) {
        this.injector = injector;
    }
}

export default Homepage;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/pages/homepage.js